import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  ShieldCheck,
  Building2,
  MapPin,
  Phone,
  Mail,
  Globe,
  Facebook,
  Users,
  Clock,
  Scale,
  UserCheck,
  Gavel,
  ArrowLeft,
} from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export default function Adatkezeles() {
  return (
    <div data-testid="adatkezeles-page" className="text-[#1A2825]">
      {/* Hero */}
      <section className="max-w-4xl mx-auto px-6 md:px-12 pt-14 md:pt-20 pb-8">
        <motion.div initial="hidden" animate="show" variants={fadeUp}>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.28em] text-[#A88A2B] hover:text-[#1C6B61] transition-colors"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> Vissza a kezdőlapra
          </Link>
          <span className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-[#A88A2B]">
            <ShieldCheck className="h-3.5 w-3.5" /> GDPR · Jogi közlemény
          </span>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light text-[#1A2825] mt-4 leading-[1.05]">
            Adatkezelési <em className="not-italic text-[#2A9D8F]">tájékoztató</em>
          </h1>
          <p className="mt-4 text-lg text-[#3A4D4A] font-light leading-relaxed">
            Fizikai közérzetjavító szolgáltatáshoz
          </p>
        </motion.div>
      </section>

      {/* Intro */}
      <section className="max-w-4xl mx-auto px-6 md:px-12 pb-10">
        <div className="prose prose-sm md:prose-base max-w-none text-[#3A4D4A] font-light leading-relaxed space-y-4">
          <p>
            Kérem, figyelmesen olvassa el a Tájékoztatót annak érdekében, hogy megértse, az
            Európai Uniós adatvédelmi rendelet (GDPR) és a hatályos jogszabályok kapcsán hogyan
            kezelem a személyes adatait és megismerje az adatkezeléssel kapcsolatos jogait. A
            vállalkozásom fenntartja magának a jogot jelen tájékoztató bármikori
            megváltoztatására, ha a rendeletben, törvényben, a vállalkozás adataiban változás
            állna be. Ha a változás olyan információkat érint, amik miatt Önt kötelezően értesíteni
            szükséges, azt haladéktalanul megteszem. Amennyiben kérdését postai úton küldte meg
            jelen tájékoztatóval kapcsolatosan, arra haladéktalanul válaszolok, de legkésőbb
            írásban egy hónapon belül.
          </p>
          <p>
            Személyes adatai (vagyis azok az adatok, amelyek az Ön személyével kapcsolatba
            hozhatók) akkor kerülhetnek a kezelésembe, ha Ön azt a tudomásomra hozza a következő
            lehetőségeken keresztül: Facebook, Viber, a vállalkozás weboldala, levelezőrendszerek,
            telefonon, élőszóban.
          </p>
          <p>
            Tájékoztatom Önt, hogy a bíróság, az ügyész, a nyomozó hatóság, a szabálysértési
            hatóság, a közigazgatási hatóság, a Nemzeti Adatvédelmi és Információszabadság
            Hatóság, a Magyar Nemzeti Bank, illetőleg jogszabály felhatalmazása alapján más
            szervek tájékoztatás adása, adatok közlése, átadása, illetőleg iratok rendelkezésre
            bocsátása végett megkereshetik a vállalkozásomat, mint adatkezelőt. A vállalkozásom
            a hatóságok részére – amennyiben a hatóság a pontos célt és az adatok körét
            megjelölte – személyes adatot csak annyit és olyan mértékben ad ki, amely a
            megkeresés céljának megvalósításához elengedhetetlenül szükséges.
          </p>
          <p>
            <strong>Takácsné Kiss Rita EV.</strong>, mint adatkezelő a tudomásomra jutott
            személyes adatokat bizalmasan kezelem és magamra nézve kötelezőnek ismerem el jelen
            jogi közlemény tartalmát.
          </p>
          <p>
            Az Ön által megadott adatokhoz email cím, telefonszám, számlázási cím fér hozzá és
            csak a számlázási adatokat <strong>Molnár Nikolett könyvelő</strong> Takácsné Kiss
            Rita EV ismerheti meg.
          </p>
          <p>
            Az informatikai eszközömön tárolt és kezelt adatok a jogosulatlan hozzáférés,
            megváltoztatás ellen védettek.
          </p>
          <p>
            A vállalkozásom tevékenységének adatkezelései önkéntes hozzájáruláson, illetve
            törvényi felhatalmazáson alapulnak. Az önkéntes hozzájáruláson alapuló adatkezelések
            esetében az érintettek e hozzájárulásukat az adatkezelés bármely szakában
            visszavonhatják. Bizonyos esetekben a megadott adatok egy körének kezelését,
            tárolását, továbbítását jogszabályok teszik kötelezővé, melyről külön értesítjük
            ügyfeleinket.
          </p>
          <p>
            Az adatkezelési tájékoztatóm folyamatosan elérhető a{" "}
            <a
              href="https://tlhmasszazs.hu"
              className="text-[#1C6B61] underline hover:text-[#2A9D8F]"
            >
              https://tlhmasszazs.hu
            </a>{" "}
            weboldalamon / TestLélek Harmónia Facebook oldalamon / stúdiómban és a kezelőlapon is
            megtalálható.
          </p>
          <p>
            Az Európai Unió Általános Adatvédelmi Rendelet (679/2016 sz. rendelet, a továbbiakban:
            GDPR) 13. cikke alapján az alábbi kötelező tájékoztatást adom:
          </p>
        </div>
      </section>

      {/* Cégadatok kártya */}
      <section className="max-w-4xl mx-auto px-6 md:px-12 pb-12">
        <div
          data-testid="adatkezeles-datacontroller"
          className="bg-white rounded-[1.75rem] border border-[#EAE5D9] p-7 md:p-9 shadow-[0_8px_28px_rgba(26,40,37,0.04)]"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="h-11 w-11 rounded-2xl bg-[#2A9D8F]/10 border border-[#2A9D8F]/25 flex items-center justify-center">
              <Building2 className="h-5 w-5 text-[#2A9D8F]" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-[#A88A2B]">Adatkezelő</div>
              <h2 className="font-serif-display text-2xl leading-snug">Az adatkezelő adatai</h2>
            </div>
          </div>
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 text-sm md:text-base">
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88]">Cégnév</dt>
              <dd className="mt-1 font-medium text-[#1A2825]">
                Takácsné Kiss Rita egyéni vállalkozó
              </dd>
              <dd className="text-xs text-[#758C88]">(adatkezelő)</dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88]">Adószám</dt>
              <dd className="mt-1 font-medium text-[#1A2825]">91295576-1-33</dd>
            </div>
            <div className="sm:col-span-2">
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88] flex items-center gap-1.5">
                <MapPin className="h-3 w-3" /> Székhely
              </dt>
              <dd className="mt-1 font-medium text-[#1A2825]">2316 Tököl, Ráckevi út 4/A 2/2</dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88] flex items-center gap-1.5">
                <Globe className="h-3 w-3" /> Weblap
              </dt>
              <dd className="mt-1">
                <a
                  href="https://tlhmasszazs.hu"
                  className="text-[#1C6B61] hover:text-[#2A9D8F] underline"
                >
                  https://tlhmasszazs.hu
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88] flex items-center gap-1.5">
                <Phone className="h-3 w-3" /> Telefon / Viber
              </dt>
              <dd className="mt-1">
                <a
                  href="tel:+3670432429"
                  className="text-[#1C6B61] hover:text-[#2A9D8F] font-medium"
                >
                  06 70 432-4269
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88] flex items-center gap-1.5">
                <Facebook className="h-3 w-3" /> Facebook
              </dt>
              <dd className="mt-1">
                <a
                  href="https://www.facebook.com/testl%C3%A9lek%20harm%C3%B3nia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1C6B61] hover:text-[#2A9D8F] underline"
                >
                  TestLélek Harmónia
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88] flex items-center gap-1.5">
                <Mail className="h-3 w-3" /> E-mail
              </dt>
              <dd className="mt-1">
                <a
                  href="mailto:dianne84@gmail.com"
                  className="text-[#1C6B61] hover:text-[#2A9D8F] underline"
                >
                  dianne84@gmail.com
                </a>
              </dd>
            </div>
          </dl>
          <div className="mt-6 pt-6 border-t border-[#EAE5D9] space-y-2 text-sm text-[#3A4D4A] font-light">
            <p>
              <strong className="text-[#1A2825]">Adatvédelmi Tisztviselő:</strong> az adatkezelő a
              GDPR 37. cikke alapján nem köteles adatvédelmi tisztviselő kinevezésére.
            </p>
            <p>
              <strong className="text-[#1A2825]">Adatvédelmi kérelmek:</strong> amennyiben
              bármilyen kérése vagy kérdése van az adatkezeléssel kapcsolatban, kérelmét postai
              úton a fent megjelölt címre és névre elküldheti. Válaszomat késedelem nélkül, de
              legfeljebb 30 napon belül küldöm az Ön által kért címre.
            </p>
            <p>
              <strong className="text-[#1A2825]">Adatfeldolgozó (hírlevél kiküldés):</strong> a
              feliratkozott e-mail címek tárolására és a hírlevelek kiküldésére a{" "}
              <strong>Brevo (Sendinblue SAS, székhely: 106 Boulevard Haussmann, 75008 Párizs,
              Franciaország)</strong> szolgáltatását veszem igénybe. A Brevo saját adatkezelési
              tájékoztatója elérhető a{" "}
              <a
                href="https://www.brevo.com/legal/privacypolicy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1C6B61] underline hover:text-[#2A9D8F]"
              >
                brevo.com/legal/privacypolicy
              </a>{" "}
              címen.
            </p>
            <p>
              <strong className="text-[#1A2825]">Adattovábbítás:</strong> az e-mail címeket a
              Brevo szolgáltatáson keresztül az{" "}
              <strong>Európai Unión belül</strong> továbbítom (Franciaország). Harmadik országba
              (EU-n kívülre) nem történik továbbítás.
            </p>
            <p>
              <strong className="text-[#1A2825]">Sütik (cookies):</strong> a weboldal csak a
              működéséhez szigorúan szükséges technikai sütiket használja. Marketing- vagy
              nyomkövető sütiket (pl. Google Analytics, Meta Pixel) nem alkalmazok.
            </p>
            <p>
              A kezelőhelységben, illetve annak várójában képi, illetve hangrögzítés nem történik.
            </p>
          </div>
        </div>
      </section>

      {/* Section 1 – Célok */}
      <NumberedSection
        num="1"
        icon={Users}
        eyebrow="1. szakasz"
        title="Adatkezelési célok"
      >
        <p>
          Masszázs és fizikai közérzetet javító szolgáltatás nyújtásához kapcsolódóan, a
          szolgáltatást igénybe vevőinek adatait <strong>jogi kötelezettség teljesítése</strong>{" "}
          és <strong>ügyfélkapcsolat fenntartása</strong> céljából kezelem.
        </p>
        <p>
          A weboldalamon keresztül feliratkozó látogatók adatait{" "}
          <strong>hírlevél küldése és direkt marketing</strong> céljából kezelem: 4Life
          termékajánlók, masszázs- és wellness-tippek, ingyenes letölthető anyagok (pl.
          Regenerációs Kisokos, Suli-hát, Aroma Flow) kiküldése, valamint az esemény- és
          akcióértesítők eljuttatása.
        </p>
        <p>
          16. életévét be nem töltött fiatalkorú személyes adatainak kezelésekor, első alkalommal
          <strong> írásbeli meghatalmazást </strong> kérek a szülőtől, vagy felügyeleti jogot
          képviselőtől.
        </p>
      </NumberedSection>

      {/* Section 2 – Jogalapok */}
      <NumberedSection
        num="2"
        icon={Scale}
        eyebrow="2. szakasz"
        title="Jogalapok az Ön személyes adatainak felhasználásához"
      >
        <p>Az Ön személyes adatainak használatát az alábbiak alapozzák meg, mint jogalapok:</p>
        <ol className="space-y-3 list-decimal list-inside marker:text-[#A88A2B] marker:font-medium">
          <li>
            Az Ön személyes adatának használata ahhoz szükséges, hogy a{" "}
            <strong>számviteli jogszabályoknak megfelelően számlát</strong> állítok ki. Jogalap:
            GDPR 6. cikk (1) bekezdés c) pont.
          </li>
          <li>
            <strong>Telefonszámára és keresztnevére</strong> kizárólag időpont-egyeztetés céljából
            van szükség. Jogalap: GDPR 6. cikk (1) bekezdés a) pont.
          </li>
          <li>
            Előfordulhat, hogy a masszázskezelés vagy/és fizikai közérzetet javító szolgáltatás
            miatt, Ön <strong>megoszt velünk egészségügyi információt</strong>. A kezelőlapot csak
            akkor készítjük el és tároljuk, amennyiben kifejezetten hozzájárul. Jogalap: GDPR 9.
            cikk (2) a) pont.
          </li>
          <li>
            <strong>E-mail címét és keresztnevét</strong> a hírlevélre való feliratkozáskor
            gyűjtöm, kizárólag hírlevél kiküldése és direkt marketing (4Life ajánlók, masszázs
            tippek, letölthető ajándékok, akciók) céljából, az Ön kifejezett{" "}
            <strong>önkéntes hozzájárulása</strong> alapján. Jogalap: GDPR 6. cikk (1) bekezdés a)
            pont.
          </li>
        </ol>
        <p>
          Hozzájárulását az időpont-egyeztetéshez a telefonszám és keresztneve megadásával
          (kezelőlap kitöltésével, aláírásával) adja meg. A hírlevélhez a weboldalon található
          feliratkozási űrlap kitöltésével és a hozzájárulás jelölőnégyzet bepipálásával
          hozzájárul. Hozzájárulását bármikor visszavonhatja — a szolgáltatásra bármely
          hírlevélben található <strong>„Leiratkozás"</strong> linkre kattintva, vagy e-mailben az{" "}
          <a
            href="mailto:dianne84@gmail.com"
            className="text-[#1C6B61] underline hover:text-[#2A9D8F]"
          >
            dianne84@gmail.com
          </a>{" "}
          címen jelezve. Amennyiben a masszázs szolgáltatáshoz szükséges adatokat nem adja meg, a
          szolgáltatást nem tudja igénybe venni.
        </p>
      </NumberedSection>

      {/* Section 3 – Mód és időtartam */}
      <NumberedSection
        num="3"
        icon={Clock}
        eyebrow="3. szakasz"
        title="Az adatkezelés módja, időtartama"
      >
        <ul className="space-y-3 list-disc list-inside marker:text-[#A88A2B]">
          <li>Az adatokat <strong>papír alapon / elektronikusan</strong> tárolom.</li>
          <li>
            A számlákat <strong>jogi kötelezettség miatt legalább 5 évig</strong> őrzöm meg.
          </li>
          <li>
            A <strong>hírlevél-feliratkozók e-mail címét és keresztnevét</strong> a leiratkozásig
            (hozzájárulás visszavonásáig) őrzöm a Brevo szolgáltatáson keresztül. Leiratkozás
            esetén az adatok haladéktalanul törlésre kerülnek.
          </li>
        </ul>
        <p>
          A kapcsolattartás céljából megadott adatokat (és a kezelőlapot) az{" "}
          <strong>utolsó találkozásunk óta eltelt fél év múlva</strong> törlöm / megsemmisítem.
        </p>
      </NumberedSection>

      {/* Section 4 – Érintetti jogok */}
      <NumberedSection
        num="4"
        icon={UserCheck}
        eyebrow="4. szakasz"
        title="Érintetti jogok"
      >
        <p>
          A személyes adataihoz kapcsolódóan Önnek a jogszabályban meghatározott jogai vannak.
          Amennyiben ezekhez kapcsolódóan további információt szeretne kapni vagy bármelyikkel
          élni kíván, bármikor kapcsolatba léphet velem.
        </p>
        <ul className="space-y-3 list-disc list-inside marker:text-[#A88A2B]">
          <li>
            <strong>Hozzáférés</strong> az Önre vonatkozó, általam kezelt adathoz; élhet
            adathordozási jogával.
          </li>
          <li>
            Amennyiben egy adat elavult vagy helytelen, ennek <strong>kiigazítása</strong>.
          </li>
          <li>
            Az Önre vonatkozó általam kezelt adat <strong>törlése</strong>; ez a jog kizárólag a
            kapcsolattartási adatokra vonatkozik.
          </li>
          <li>Az adat kezelésének <strong>korlátozása</strong>.</li>
          <li>
            Az Ön személyes adatának <strong>direkt marketing célokra való használatának
            megtiltása</strong>.
          </li>
          <li>
            Személyes adatainak <strong>harmadik személy szolgáltató számára történő átadása</strong>,
            vagy ennek megtiltása.
          </li>
          <li>
            Bármely Önre vonatkozó, általam kezelt személyes adatról <strong>másolat adása</strong>.
          </li>
          <li><strong>Tiltakozás</strong> a személyes adatok általam történő használata ellen.</li>
        </ul>
      </NumberedSection>

      {/* Section 5 – Jogorvoslat / NAIH */}
      <section className="max-w-4xl mx-auto px-6 md:px-12 pb-16">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-11 w-11 rounded-2xl bg-[#1C6B61]/10 border border-[#1C6B61]/25 flex items-center justify-center">
            <Gavel className="h-5 w-5 text-[#1C6B61]" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#A88A2B]">5. szakasz</div>
            <h2 className="font-serif-display text-2xl md:text-3xl leading-snug">
              Jogorvoslati tájékoztatás
            </h2>
          </div>
        </div>
        <div
          data-testid="adatkezeles-naih"
          className="bg-[#F6F3EB] rounded-[1.75rem] border border-[#EAE5D9] p-7 md:p-9"
        >
          <p className="text-sm md:text-base text-[#3A4D4A] font-light leading-relaxed">
            Magyarországon az adatvédelmi felügyeleti hatóság:
          </p>
          <div className="mt-3 font-serif-display text-xl md:text-2xl text-[#1A2825] leading-snug">
            Nemzeti Adatvédelmi és Információszabadság Hatóság
          </div>
          <dl className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-sm">
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88]">Cím</dt>
              <dd className="mt-0.5 text-[#1A2825]">1055 Budapest, Falk Miksa utca 9-11</dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88]">
                Levelezési cím
              </dt>
              <dd className="mt-0.5 text-[#1A2825]">1363 Budapest, Pf.: 9.</dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88]">Telefon</dt>
              <dd className="mt-0.5">
                <a
                  href="tel:+3613911400"
                  className="text-[#1C6B61] hover:text-[#2A9D8F] font-medium"
                >
                  +36 (1) 391 1400
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88]">Fax</dt>
              <dd className="mt-0.5 text-[#1A2825]">+36 (1) 391 1410</dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88]">E-mail</dt>
              <dd className="mt-0.5">
                <a
                  href="mailto:ugyfelszolgalat@naih.hu"
                  className="text-[#1C6B61] hover:text-[#2A9D8F] underline"
                >
                  ugyfelszolgalat@naih.hu
                </a>
              </dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.25em] text-[#758C88]">Honlap</dt>
              <dd className="mt-0.5">
                <a
                  href="http://www.naih.hu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1C6B61] hover:text-[#2A9D8F] underline"
                >
                  www.naih.hu
                </a>
              </dd>
            </div>
          </dl>
        </div>
      </section>

      {/* Vissza gomb */}
      <section className="max-w-4xl mx-auto px-6 md:px-12 pb-20">
        <div className="mb-6 pb-6 border-b border-[#EAE5D9] text-xs text-[#758C88] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <span data-testid="adatkezeles-updated">Utoljára frissítve: 2026. február 10.</span>
          <span className="italic font-serif-display text-[#A88A2B] text-sm">
            „A harmónia belül kezdődik – és kívül látszik.”
          </span>
        </div>
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#1C6B61] hover:text-[#A88A2B] transition-colors"
        >
          <ArrowLeft className="h-4 w-4" /> Vissza a kezdőlapra
        </Link>
      </section>
    </div>
  );
}

function NumberedSection({ num, icon: Icon, eyebrow, title, children }) {
  return (
    <section className="max-w-4xl mx-auto px-6 md:px-12 pb-12">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-11 w-11 rounded-2xl bg-[#D4AF37]/12 border border-[#D4AF37]/30 flex items-center justify-center">
          <Icon className="h-5 w-5 text-[#A88A2B]" />
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.28em] text-[#A88A2B]">{eyebrow}</div>
          <h2 className="font-serif-display text-2xl md:text-3xl leading-snug">
            <span className="font-serif-display text-[#2A9D8F] mr-2">{num}.</span>
            {title}
          </h2>
        </div>
      </div>
      <div className="text-sm md:text-base text-[#3A4D4A] font-light leading-relaxed space-y-4">
        {children}
      </div>
    </section>
  );
}
